<ng-container *ngIf="!production">
    <ng-container *ngIf="minimized; else fullContent">
        <div class="env-indicator d-flex justify-content-end align-items-center" cdkDrag>
            <span class="material-icons env-indicator__icon">
                science
            </span>
            <span class="env-indicator__label">{{label}}</span>
        </div>
    </ng-container>
    <ng-template #fullContent>
        <div class="env-banner d-flex justify-content-between align-items-center position-fixed"
            [class.minimizing]="minimizing">
            <div class="env-banner__content flex-grow-1 d-flex justify-content-center align-items-center py-1">
                <span class="material-icons env-banner__icon">
                    science
                </span>
                <span class="env-banner__label">{{label}} environment</span>
            </div>
            <div class="env-banner__actions mx-2">
                <button type="button" class="btn-link btn-link-primary m-0" title="Minimize" (click)="minimize()">
                    <span class="material-icons align-bottom">
                        close
                    </span>
                </button>
            </div>
        </div>
    </ng-template>
</ng-container>